import { lazy, Suspense } from 'react'

import { cn } from '@/lib/utils'

import type { RichTextEditorProps } from './rich-text-editor-impl'

/* the editor (tiptap + prosemirror + emoji-picker) is large and only used in
 * the message composers, so load it lazily — this keeps it out of the initial
 * bundle and into an on-demand chunk that loads when a composer first mounts.
 * the public api is unchanged; callers import RichTextEditor exactly as before.
 */
const RichTextEditorImpl = lazy(() =>
  import('./rich-text-editor-impl').then(module => ({
    default: module.RichTextEditor
  }))
)

export function RichTextEditor(props: RichTextEditorProps) {
  return (
    <Suspense
      fallback={
        <div
          className={cn(
            'min-h-[78px] rounded-md border border-border bg-page',
            props.className
          )}
        />
      }
    >
      <RichTextEditorImpl {...props} />
    </Suspense>
  )
}
